import { TestNamespaceType } from '~/enums/TestNamespaceType';

import { createTestId } from './createTestId';

export const DOC_VIEW_PAGE_LAYOUT_BUTTON_GROUP_TESTID = createTestId({
  namespace: TestNamespaceType.DocumentsViewPage,
  block: 'layout-button-group',
});
